<template>
  <div>
    <head-nav-bar title="房情预测" :fixed="true" left-arrow />
    <div class="mt-header-nav">
      <van-row type="flex" style="margin-top:10px" justify="space-around">
        <van-col span="18">
          <DateRangePicker
            :min="min"
            :max="max"
            :value.sync="daterange"
          ></DateRangePicker>
        </van-col>
        <van-col span="4">
          <van-button type="info" size="small" @click="onSearch">
            查询
          </van-button>
        </van-col>
      </van-row>
      <div class="wrap">
        <!-- 头部日历 -->
        <div
          class="main-header scroll-hidden"
          ref="mainHeader"
          @scroll="headerScroll"
          @touchstart="forwardMouseenter('header')"
          style="padding-left:155px"
        >
          <table :style="' width: ' + 78 * 15 + 'px'">
            <tr>
              <td
                v-for="(item, index) in companyData[0] &&
                  companyData[0].Details"
                :key="index"
              >
                <div
                  :class="{
                    isWeekend: item.DayOfWeek == '6' || item.DayOfWeek == '0',
                    istoday: isAccountDate(item.Date),
                  }"
                >
                  <p>
                    {{ isAccountDate(item.Date) ? "今天" : item.Date }}
                  </p>
                  <span>{{ item.Quantity }}间</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div
          class="main-content scroll-hidden"
          ref="mainContent"
          style="margin-top: -1px;padding-left:155px"
          @scroll="mainScroll"
          @touchstart="forwardMouseenter('main')"
        >
          <table
            :style="' width: ' + 78 * 15 + 'px'"
            v-for="(item1, index1) in companyData"
            :key="index1"
            @click="checkDetail(item1)"
          >
            <tr>
              <td v-for="(item2, index2) in item1.Details" :key="index2">
                {{ item2.RentRate }}
              </td>
            </tr>
            <tr>
              <td v-for="(item2, index2) in item1.Details" :key="index2">
                {{ item2.PredictRoomPrice }}
              </td>
            </tr>
            <tr>
              <td v-for="(item2, index2) in item1.Details" :key="index2">
                {{ item2.AvgRoomPrice }}
              </td>
            </tr>
          </table>
        </div>
        <!-- 左侧栏房型房号 -->
        <div class="fixed-left">
          <div class="fixed-header">
            <table style="width:156px">
              <tr>
                <td>
                  门店
                </td>
                <td>
                  总计
                </td>
              </tr>
            </table>
          </div>
          <div class="outer-container" style="margin-top: -1px;">
            <div
              class="fixed-content scroll-hidden"
              ref="fixedContent"
              @touchstart="forwardMouseenter('fixed')"
              @scroll="fixedScroll"
            >
              <table
                v-for="(item3, index3) in companyData"
                :key="index3"
                style="width:156px"
              >
                <tr>
                  <td rowspan="3">{{ item3.CompanyName }}</td>
                  <td class="td-title">出租率</td>
                </tr>
                <tr>
                  <td>房费预测</td>
                </tr>
                <tr>
                  <td>平均房价</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue";
import groupRoomApi from "../../api/group_room.js";
import { getGSelectData } from "@/api/common.js";
import { mapState } from "vuex";
import { Row, Col, Button } from "vant";
import { jump } from "@/utils/common.js";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    DateRangePicker,
  },
  data() {
    return {
      min: "",
      max: "",
      daterange: [],
      roomData: [],
      companyData: [],
    };
  },
  created() {
    this.min = this.user.AccountDate;
    this.max = moment(this.user.AccountDate)
      .add(14, "d")
      .format("YYYY-MM-DD");
    this.daterange = [this.min, this.max];

    getGSelectData({ Types: "company" }).then(() => {
      // this.companyData = res.Data.company;
      let item = {
        StartDate: this.user.AccountDate,
        EndDate: moment(this.user.AccountDate)
          .add(14, "d")
          .format("YYYY-MM-DD"),
        PageIndex: 0,
        PageSize: 5,
      };
      this.getData(item);
    });
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
    isAccountDate() {
      return function(val) {
        return val == moment(this.user.AccountDate).format("MM-DD");
      };
    },
  },
  methods: {
    getData(params) {
      groupRoomApi.GetGroupRoomForecast(params).then(res => {
        this.companyData = res.Data.Datas.concat(res.Data.Datas);
      });
    },
    checkDetail(item) {
      jump("groupRoomForecastDetail", { Id: item.Id, Name: item.CompanyName });
    },
    onSearch() {
      const params = {
        CompanyId: this.user.CompanyId,
        StartDate: this.daterange[0],
        EndDate: this.daterange[1],
      };
      this.getData(params);
    },
    headerScroll(e) {
      if (this.mouseType == "header") {
        this.$refs.mainContent.scrollLeft = e.currentTarget.scrollLeft;
      }
    },
    fixedScroll(e) {
      if (this.mouseType == "fixed") {
        this.$refs.mainContent.scrollTop = e.currentTarget.scrollTop;
      }
    },
    mainScroll(e) {
      if (this.mouseType == "main") {
        this.$refs.fixedContent.scrollTop = e.currentTarget.scrollTop;
        this.$refs.mainHeader.scrollLeft = e.currentTarget.scrollLeft;
      }
    },
    forwardMouseenter(type) {
      this.mouseType = type;
    },
  },
};
</script>
<style lang="less" scoped>
@import "./RoomForecast.less";
</style>
